<script setup lang="ts">
import { Skeleton } from '@laam/ui/base';
import { PhMagnifyingGlass } from '@phosphor-icons/vue';
</script>

<template>
	<div>
		<div class="flex flex-col lg:px-3xl gap-md">
			<div class="py-xl">
				<Skeleton class="w-[200px] h-5xl bg-gray-200 rounded-xs" />
			</div>

			<div class="py-xl flex flex-row gap-7xl">
				<div
					v-for="(_, idx) in [1, 2, 3, 4, 5]"
					:key="idx"
					class="flex flex-col items-center gap-xs"
				>
					<Skeleton class="w-[74px] h-[74px] bg-gray-200 rounded-sm" />
					<Skeleton class="w-[50px] h-lg bg-gray-200 rounded-xs" />
				</div>
			</div>
		</div>

		<div class="flex flex-col gap-md">
			<div class="py-xl lg:px-3xl">
				<Skeleton class="w-[200px] h-5xl bg-gray-200 rounded-xs" />
			</div>

			<div class="flex flex-col lg:px-sm gap-xs">
				<div
					v-for="(_, idx) in [1, 2, 3, 4]"
					:key="idx"
					class="lg:px-lg py-lg flex items-center gap-lg"
				>
					<PhMagnifyingGlass size="20" class="text-gray-400" />
					<Skeleton class="w-[250px] h-[20px] bg-gray-200 rounded-xs" />
				</div>
			</div>
		</div>

		<div class="flex flex-col gap-md">
			<div class="py-xl lg:px-3xl">
				<Skeleton class="w-[200px] h-5xl bg-gray-200 rounded-xs" />
			</div>

			<div class="flex flex-col lg:px-sm gap-xs">
				<div
					v-for="(_, idx) in [1, 2]"
					:key="idx"
					class="lg:px-lg py-lg flex items-center gap-lg"
				>
					<PhMagnifyingGlass size="20" class="text-gray-400" />
					<Skeleton class="w-[250px] h-[20px] bg-gray-200 rounded-xs" />
				</div>
			</div>
		</div>
	</div>
</template>
